import * as amplitude from '@amplitude/analytics-browser';
import { init } from '@amplitude/engagement-browser';
import type { History } from 'history';
import { amplitudeEngagementConfig } from '@config';

// ts-prune-ignore-next
export class AmplitudeEngagement {
  private hasInitialized = false;

  private hasBooted = false;

  private get enabled() {
    return amplitudeEngagementConfig.apiKey;
  }

  public init(history: History) {
    if (!this.enabled || this.hasInitialized) {
      return;
    }

    // Initialize Amplitude Analytics with autocapture disabled so Engagement insights
    // are forwarded without emitting automatic page-view/session noise.
    amplitude.init(amplitudeEngagementConfig.apiKey, { autocapture: false });

    // Initialize Amplitude Engagement
    init(amplitudeEngagementConfig.apiKey);

    // Attach to router (init() is synchronous and sets up window.engagement immediately)
    window.engagement?.setRouter((newUrl: string) => history.push(newUrl));

    this.hasInitialized = true;
  }

  public async boot(userId: string, userProperties?: Record<string, unknown>) {
    if (!this.hasInitialized || this.hasBooted) {
      // eslint-disable-next-line
      console.warn('[amplitude-engagement]: cannot boot before init');
      return;
    }

    // Boot Amplitude Engagement for the current user
    await window.engagement.boot({
      user: {
        user_id: userId,
        user_properties: userProperties,
      },
      integrations: [amplitude],
    });

    this.hasBooted = true;
  }

  public shutdown() {
    if (!this.hasInitialized) {
      // eslint-disable-next-line
      console.warn('[amplitude-engagement]: cannot shutdown before boot');
      return;
    }

    window.engagement.shutdown();
    this.hasBooted = false;
  }
}

export const amplitudeEngagement = new AmplitudeEngagement();
